import { IRequesterInfo } from '../../../../base/models'
import { ClientProxy } from '../../../../base/proxy/clientProxy'
import { IPaymentCurrencyControl } from '../models/PaymentModel'

export class GetPaymentCurrencyControlApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'payment/getPaymentCurrencyControl',
      requesterInfo,
    })
  }

  public async getPaymentCurrencyControl(): Promise<IPaymentCurrencyControl> {
    return await this.getAsync<IPaymentCurrencyControl>()
  }
}
